import React from "react";

import classNames from "classnames";

import { makeStyles } from "@material-ui/core/styles";

import Camera from "@material-ui/icons/Camera";
import Palette from "@material-ui/icons/Palette";
import AppsIcon from "@material-ui/icons/Apps";

import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import NavPills from "components/NavPills/NavPills.js";
import Parallax from "components/Parallax/Parallax.js";

import profile from "assets/img/faces/RachitMehrotra.jpg";

import studio1 from "assets/img/Images/docker.png";
import studio3 from "assets/img/Images/JS.png";
import work1 from "assets/img/Images/spring.jpg";
import work2 from "assets/img/Images/RN.jpg";
import work4 from "assets/img/Images/1200px-React-icon.svg.png";

import nodejs from "assets/img/Images/Nodejs.png";
import angular from "assets/img/Images/Angular.png";

import styles from "assets/jss/material-kit-react/views/profilePage.js";

const useStyles = makeStyles(styles);

export default function ResumePage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
  return (
    <div>
      <Header
        color="white"
        brand="Rachit Mehrotra.io"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "white",
        }}
        {...rest}
      />
      <Parallax
        small
        filter
        image={require("assets/img/Images/homepage.jpg")}
      />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={6}>
                <div className={classes.profile}>
                  <div>
                    <img src={profile} alt="..." className={imageClasses} />
                  </div>
                  <div className={classes.name}>
                    <h3 className={classes.title}>Rachit Mehrotra</h3>
                    <h5>FULL STACK DEVELOPER</h5>
                    <h6>Candela Labs</h6>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
            <div className={classes.description}>
              <p>
                4+ Years. A senior software engineer. I enjoy creating things
                that live on the internet or intranet, whether that be websites,
                applications, or anything in between. My goal is to always build
                products that provide pixel-perfect, performant experiences. I'm
                quietly confident, naturally curious, and perpetually working on
                improving and upskilling always.
              </p>
            </div>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={8} className={classes.navWrapper}>
                <NavPills
                  alignCenter
                  color="info"
                  tabs={[
                    {
                      tabButton: "Projects",
                      tabIcon: Camera,
                      tabContent: (
                        <GridContainer justify="center">

                          <GridItem xs={12} sm={12} md={4}>
                            <h5>Payment Automation</h5>
                            <h6>In-Progress</h6>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <h5>PIVM</h5>
                            <h6>Completed</h6>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <h5>UWM</h5>
                            <h6>Completed</h6>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <h5>Payment Portal</h5>
                            <h6>Completed</h6>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <h5>PCS</h5>
                            <h6>Completed</h6>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <h5>Data Collector</h5>
                            <h6>Completed</h6>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <h5>Enquire Mode</h5>
                            <h6>Completed</h6>
                          </GridItem>
                        </GridContainer>
                      ),
                    },
                    {
                      tabButton: "Clients",
                      tabIcon: Palette,
                      tabContent: (
                        <GridContainer justify="center">
                          <GridItem>
                            <h5>PRUDENTIAL MALAYISA</h5>
                            <h6>Active</h6>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <h5>PRUDENTIAL THAILAND</h5>
                            <h6>Non Active</h6>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <h5>PRUDENTIAL SINGAPORE</h5>
                            <h6>Non Active</h6>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <h5>PRUDENTIAL VIETNAM</h5>
                            <h6>Non Active</h6>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <h5>FWD VIETNAM</h5>
                            <h6>Non Active</h6>
                          </GridItem>
                        </GridContainer>
                      ),
                    },
                    {
                      tabButton: "My Skills",
                      tabIcon: AppsIcon,
                      tabContent: (
                        <GridContainer justify="center">
                          <GridItem xs={12} sm={12} md={4}>
                            <img
                              alt="..."
                              src={work4}
                              className={navImageClasses}
                            />
                            <img
                              alt="..."
                              src={studio3}
                              className={navImageClasses}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <img
                              alt="..."
                              src={work2}
                              className={navImageClasses}
                            />
                            <img
                              alt="..."
                              src={work1}
                              className={navImageClasses}
                            />
                            <img
                              alt="..."
                              src={studio1}
                              className={navImageClasses}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <img
                              alt="..."
                              src={nodejs}
                              className={navImageClasses}
                            />
                            <img
                              alt="..."
                              src={angular}
                              className={navImageClasses}
                            />
                          </GridItem>
                        </GridContainer>
                      ),
                    },
                  ]}
                />
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
